import styled, { css } from 'styled-components';

export const FeatureListCard = styled.div`
  background: #ffffff;
  border-radius: 0.75rem;
  padding: 0.25rem 0;
`;

const featureRowLayout = css`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0.75rem 1rem;
  border: none;
  border-bottom: 1px solid #e2e4e7;
  background: none;
  font-family: inherit;
  text-align: left;
  color: inherit;

  &:last-child {
    border-bottom: none;
  }
`;

export const FeatureRowItem = styled.div`
  ${featureRowLayout}
`;

export const FeatureRowButton = styled.button.attrs({ type: 'button' })`
  ${featureRowLayout}
  cursor: pointer;

  &:focus-visible {
    outline: 0.125rem solid ${({ theme }) => theme.color.ui.blue[70]};
    outline-offset: -0.125rem;
  }
`;

/* Fills the row so the screen reader highlight matches it. Opacity keeps the text in the
   accessibility tree; clipping it to 1px would shrink that highlight to a dot. */
export const RowAnnouncement = styled.p`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  user-select: none;
`;

export const FeatureTopRow = styled.div`
  display: flex;
  align-items: center;
`;

export const FeatureName = styled.div`
  flex: 1;
  display: block;
  min-width: 0;
  margin-right: 0.5rem;
`;

export const FeatureText = styled.span<{ $dimmed?: boolean }>`
  font-size: 1rem;
  font-weight: ${({ $dimmed }) => ($dimmed ? 400 : 500)};
  line-height: 1.5rem;
  color: ${({ theme, $dimmed }) => ($dimmed ? theme.color.ui.grey[70] : theme.color.ui.grey[100])};
`;

/** Keeps a label's final word and its info icon on the same line — see `splitTrailingWord`. */
export const FeatureLastWord = styled.span`
  white-space: nowrap;
`;

export const FeatureValueCell = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const FeatureQualifierText = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  margin-top: 0.25rem;
`;

export const FeatureInfoIcon = styled.span`
  display: inline-flex;
  vertical-align: middle;
  margin-left: 0.5rem;
`;
